import React from 'react';

function CalorieProgress({ current, goal }) {
  const percentage = goal > 0 ? Math.round((current / goal) * 100) : 0;
  const remaining = goal - current;

  let colorClass = 'progress-green';
  if (percentage >= 100) {
    colorClass = 'progress-red';
  } else if (percentage >= 80) {
    colorClass = 'progress-orange';
  }

  const barWidth = Math.min(percentage, 100);

  return (
    <div className="calorie-progress">
      <div className="calorie-numbers">
        <span className={`calorie-current ${colorClass}`}>{current}</span>
        <span className="calorie-separator"> / </span>
        <span className="calorie-goal">{goal}</span>
      </div>
      <div className="calorie-label">calories</div>

      <div className="progress-bar-track">
        <div
          className={`progress-bar-fill ${colorClass}`}
          style={{ width: `${barWidth}%` }}
        />
      </div>

      <div className={`calorie-remaining ${colorClass}`}>
        {remaining >= 0
          ? `${remaining} remaining`
          : `${Math.abs(remaining)} over goal`
        }
      </div>
    </div>
  );
}

export default CalorieProgress;
